import CryptoJS from "crypto-js";

// Use a secret key - in production, this should be stored securely
// For end-to-end encryption, each chat should ideally have its own key
const SECRET_KEY =
  process.env.REACT_APP_ENCRYPTION_KEY || "ATO-SECURE-CHAT-2026";

/**
 * Encrypt a message before sending
 * @param {string} message - Plain text message
 * @returns {string} Encrypted message
 */
export const encryptMessage = (message) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(message, SECRET_KEY).toString();
    return encrypted;
  } catch (error) {
    console.error("Encryption error:", error);
    return message; // Return original if encryption fails
  }
};

/**
 * Decrypt a message after receiving
 * @param {string} encryptedMessage - Encrypted message
 * @returns {string} Decrypted plain text message
 */
export const decryptMessage = (encryptedMessage) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedMessage, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || encryptedMessage; // Return original if decryption fails
  } catch (error) {
    console.error("Decryption error:", error);
    return encryptedMessage; // Return encrypted text if decryption fails
  }
};

/**
 * Check if a message is encrypted
 * @param {string} message - Message to check
 * @returns {boolean} True if message appears to be encrypted
 */
export const isEncrypted = (message) => {
  // AES encrypted messages from crypto-js start with "U2FsdGVkX1"
  return message && message.startsWith("U2FsdGVkX1");
};
